import type { PropsWithChildren } from 'react';

import { useConditionalFieldsContext } from '../conditional-fields-provider/ConditionalFieldsContext';
import { useRiskSmartForm } from './RiskSmartFormContext';

type Props = {
  sectionId: string;
};

function ConditionalSection({ sectionId, children }: PropsWithChildren<Props>) {
  const { hiddenSections } = useConditionalFieldsContext();
  const { editMode } = useRiskSmartForm();

  // Show all sections when editing
  const isVisible = !hiddenSections.has(sectionId) || editMode;

  return isVisible ? children : null;
}

export default ConditionalSection;
